import React, { useContext } from 'react';

import { Grid, Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { useContainer } from 'unstated-next';
import { ClassSessionContext } from '../../../ClassSessionContext';
import AdminAuthContainer from '../../../AdminAuthContainer';

const Spacer = styled.div`
    margin: 1rem;
`;

const PaddedSkeleton = styled(Skeleton)`
    margin: .5rem 0;
`;

export const ClassSessionDetailStudy = () => {
    const { t } = useTranslation('portal');
    const { classSessionContent } = useContext(ClassSessionContext);
    const { authMode } = useContainer(AdminAuthContainer);
    console.log('ClassSessionDetailContent classSessionContent', classSessionContent, 'authMode', authMode, 't', t);

    if (classSessionContent.loading) {
        return (
            <>
                <Grid container justifyContent="space-between">
                    <Grid item><Skeleton width={300} height={60}/></Grid>
                    <Grid item><Skeleton width={150} height={60}/></Grid>
                </Grid>
                <Spacer />
                <PaddedSkeleton height={35}/>
                <PaddedSkeleton height={35}/>
                <PaddedSkeleton height={35}/>
                <PaddedSkeleton height={35}/>
                <PaddedSkeleton height={35}/>
                <Spacer />
                <Grid container justifyContent="flex-end">
                    <Skeleton width={400} height={50}/>
                </Grid>
            </>
        );
    }

    return (
        <>
        </>
    );
};
